import React from 'react';

export default function StatsSection({ blok }) {
  const { heading, stats, disclaimer} = blok;
  return (
    <div className="bg-black relative">
      <div className="hidden md:block md:absolute right-0 top-0 w-1/4 lg:w-1/3">
        <img src="https://a-us.storyblok.com/f/1001720/1058x584/891cad85a6/stats-section-embellishment.png" loading='lazy' className="img-object-cover" alt="side graphic" />
      </div>
      <div className="container">
        <div className="mb-24 lg:mb-32">{heading && <h2 className={`max-w-xl u-h2 text-white`} dangerouslySetInnerHTML={{ __html: heading }}></h2>}</div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-24">
          {stats?.map((itm, i) => (
            <div key={i} className="text-center text-white">
              <h3 className={`text-5xl xl:text-6xl font-semibold md:mb-4 lg:mb-8 circle-ring-stretch ${!(i % 2) ? 'circle-ring-top ' : 'circle-ring-bottom'}`}>
                {itm?.heading}
              </h3>
              <div className="text-xl">{itm?.content}</div>
            </div>
          ))}
        </div>
        {disclaimer && <div className="disclaimer mt-20 text-center text-white text-sm">{disclaimer}</div>}
      </div>
    </div>
  );
}
